import { render, staticRenderFns } from "./DisplayLessonItems.vue?vue&type=template&id=0b70b300"
import script from "./DisplayLessonItems.vue?vue&type=script&lang=js"
export * from "./DisplayLessonItems.vue?vue&type=script&lang=js"
import style0 from "./DisplayLessonItems.vue?vue&type=style&index=0&id=0b70b300&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports